// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module__container___1D1Ly","main":"layout-module__main___13VFN"};